var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinalfailure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 0L108.531 0.821297L120.847 3.27112L132.738 7.30756L144 12.8616L154.441 19.8381L163.882 28.1178L172.162 37.5589L179.138 48L184.692 59.2624L188.729 71.1534L191.179 83.4695L192 96L191.179 108.531L188.729 120.847L184.692 132.738L179.138 144L172.162 154.441L163.882 163.882L154.441 172.162L144 179.138L132.738 184.692L120.847 188.729L108.531 191.179L96 192L83.4695 191.179L71.1534 188.729L59.2624 184.692L48 179.138L37.5589 172.162L28.1178 163.882L19.8381 154.441L12.8616 144L7.30756 132.738L3.27112 120.847L0.821297 108.531L0 96L0.821297 83.4695L3.27112 71.1534L7.30756 59.2624L12.8616 48L19.8381 37.5589L28.1178 28.1178L37.5589 19.8381L48 12.8616L59.2624 7.30756L71.1534 3.27112L83.4695 0.821297L96 0Z",
    fill: "#E53C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65.9741L96 95.9741L126 125.974M126 65.9741L66 125.974",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalfailure);
export default __webpack_public_path__ + "static/media/finalfailure.d1e72d4c36863b27cc9fc0fb25765021.svg";
export { ForwardRef as ReactComponent };